/* Buffalo: contenido de fábrica (fotos + videos) mezclado en banners, fichas de producto y la página /pages/fabrica.
   Los datos vienen de bf-fabrica-data.js (window.BF_FABRICA): {t:'i',u,w,h} foto · {t:'v',p,w,h,s:[{u,h}]} video. */
(function () {
  if (window.bfFabrica) return;
  var DATA = window.BF_FABRICA || [];
  if (!DATA.length) return;
  var PAGE = '/pages/fabrica';
  var conn = navigator.connection || {};
  var saveData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  function shuffle(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function img(u, w) { return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  function pickSource(it, target) {
    var s = it.s || [];
    if (!s.length) return null;
    var best = s[s.length - 1];
    for (var i = 0; i < s.length; i++) { if (s[i].h >= target) { best = s[i]; break; } }
    return best.u;
  }
  function still(it) { return it.t === 'v' ? it.p : it.u; }
  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    for (var k in (attrs || {})) e.setAttribute(k, attrs[k]);
    return e;
  }

  /* n elementos al azar con al menos 1 video y 1 foto si es posible */
  function sample(n) {
    var vids = shuffle(DATA.filter(function (d) { return d.t === 'v'; }));
    var pics = shuffle(DATA.filter(function (d) { return d.t === 'i'; }));
    var out = [];
    if (vids.length && n > 1) out.push(vids[0]);
    while (out.length < n && pics.length) out.push(pics.shift());
    while (out.length < n && vids.length > 1) out.push(vids.splice(1, 1)[0]);
    return shuffle(out);
  }

  /* ---------- Banners ---------- */
  function slide(it) {
    var a = el('a', 'buffalo-banner-rotator__slide bf-fab-slide', { href: PAGE, 'aria-label': 'Fábrica Buffalo: ver fotos y videos' });
    var bg = el('img', 'bf-fab-slide__bg', { src: img(still(it), 400), alt: '', 'aria-hidden': 'true', loading: 'lazy' });
    a.appendChild(bg);
    var fg;
    if (it.t === 'v') {
      fg = el('video', 'bf-fab-slide__fg', { muted: '', loop: '', playsinline: '', preload: 'none', poster: img(it.p, 1000), 'aria-hidden': 'true', tabindex: '-1' });
      fg.muted = true;
      fg.dataset.src = saveData ? '' : (pickSource(it, 720) || '');
    } else {
      fg = el('img', 'bf-fab-slide__fg', { src: img(it.u, 1200), alt: 'Fábrica Buffalo', loading: 'lazy', width: it.w, height: it.h });
    }
    a.appendChild(fg);
    a.appendChild(el('span', 'bf-fab-slide__tag')).textContent = 'Fábrica Buffalo';
    return a;
  }
  function addToRotator(root) {
    if (root.dataset.bfFab) return;
    root.dataset.bfFab = '1';
    var slides = [].slice.call(root.querySelectorAll('.buffalo-banner-rotator__slide'));
    sample(4).forEach(function (it) {
      var pos = 1 + Math.floor(Math.random() * slides.length); /* nunca primero: el banner de Plan Canje sigue abriendo */
      var ref = slides[pos] || null;
      var s = slide(it);
      if (ref) root.insertBefore(s, ref); else root.insertBefore(s, root.querySelector('.buffalo-banner-rotator__dots'));
      slides.splice(pos, 0, s);
    });
  }
  function playVideo(slideEl, on) {
    var v = slideEl && slideEl.querySelector('video');
    if (!v) return;
    if (on) {
      if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; v.preload = 'auto'; }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    } else { v.pause(); }
  }

  /* ---------- Fichas de producto: "También te puede interesar" ---------- */
  function tile(it, w) {
    var d = el('div', 'resource-list__item bf-fab-item');
    var a = el('a', 'bf-fab-tile', { href: PAGE, 'aria-label': 'Fábrica Buffalo' });
    var i = el('img', '', { src: img(still(it), w || 600), alt: 'Fábrica Buffalo', loading: 'lazy', width: it.w || 800, height: it.h || 800 });
    a.appendChild(i);
    if (it.t === 'v') a.appendChild(el('span', 'bf-fab-play', { 'aria-hidden': 'true' }));
    d.appendChild(a);
    return d;
  }
  function enhanceRecs(pr) {
    var list = pr.querySelector('.resource-list[data-has-recommendations="true"]');
    if (!list || list.dataset.bfFab || !list.children.length) return false;
    list.dataset.bfFab = '1';
    var items = sample(4);
    var kids = [].slice.call(list.children);
    items.forEach(function (it, n) {
      /* intercalado al azar entre los productos, nunca como primer elemento */
      var ref = kids[Math.min(kids.length, 1 + Math.floor(Math.random() * (kids.length + n)))];
      var t = tile(it);
      if (ref && ref.parentNode === list) list.insertBefore(t, ref); else list.appendChild(t);
    });
    return true;
  }
  function watchRecs() {
    var pr = document.querySelector('product-recommendations');
    if (!pr) return;
    if (enhanceRecs(pr)) return;
    new MutationObserver(function (_, mo) { if (enhanceRecs(pr)) mo.disconnect(); }).observe(pr, { childList: true, subtree: true });
  }

  /* ---------- Página /pages/fabrica ---------- */
  function lightbox() {
    var dlg = document.querySelector('.bf-fab-dialog');
    if (dlg) return dlg;
    dlg = el('dialog', 'bf-fab-dialog', { 'aria-label': 'Fábrica Buffalo' });
    dlg.innerHTML = '<button type="button" class="bf-fab-dialog__close" aria-label="Cerrar">&times;</button>' +
      '<button type="button" class="bf-fab-dialog__nav bf-fab-dialog__nav--prev" aria-label="Anterior">&#8249;</button>' +
      '<button type="button" class="bf-fab-dialog__nav bf-fab-dialog__nav--next" aria-label="Siguiente">&#8250;</button>' +
      '<div class="bf-fab-dialog__stage"></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.querySelector('.bf-fab-dialog__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('close', function () { dlg.querySelector('.bf-fab-dialog__stage').innerHTML = ''; });
    return dlg;
  }
  function openAt(list, i) {
    var dlg = lightbox();
    var it = list[i];
    var stage = dlg.querySelector('.bf-fab-dialog__stage');
    stage.innerHTML = '';
    if (it.t === 'v') {
      var v = el('video', '', { controls: '', autoplay: '', playsinline: '', poster: img(it.p, 1200) });
      v.src = pickSource(it, 1080);
      stage.appendChild(v);
    } else {
      stage.appendChild(el('img', '', { src: img(it.u, 1800), alt: 'Fábrica Buffalo' }));
    }
    dlg.querySelector('.bf-fab-dialog__nav--prev').onclick = function () { openAt(list, (i - 1 + list.length) % list.length); };
    dlg.querySelector('.bf-fab-dialog__nav--next').onclick = function () { openAt(list, (i + 1) % list.length); };
    if (!dlg.open) dlg.showModal();
  }
  function buildGallery(root) {
    /* videos repartidos parejo entre las fotos */
    var vids = DATA.filter(function (d) { return d.t === 'v'; });
    var pics = DATA.filter(function (d) { return d.t === 'i'; });
    var list = [];
    var every = vids.length ? Math.max(2, Math.floor((pics.length + vids.length) / vids.length)) : 0;
    var vi = 0, pi = 0;
    while (pi < pics.length || vi < vids.length) {
      if (vi < vids.length && every && (list.length + 1) % every === 0) list.push(vids[vi++]);
      else if (pi < pics.length) list.push(pics[pi++]);
      else list.push(vids[vi++]);
    }
    var grid = root.querySelector('.bf-fab-grid');
    list.forEach(function (it, n) {
      var b = el('button', 'bf-fab-card', { type: 'button', 'aria-label': (it.t === 'v' ? 'Ver video ' : 'Ver foto ') + (n + 1) + ' de ' + list.length });
      var im = el('img', '', { src: img(still(it), 700), alt: '', loading: 'lazy', width: it.w || 800, height: it.h || 600 });
      b.appendChild(im);
      if (it.t === 'v') b.appendChild(el('span', 'bf-fab-play', { 'aria-hidden': 'true' }));
      b.addEventListener('click', function () { openAt(list, n); });
      grid.appendChild(b);
    });
  }

  window.bfFabrica = { addToRotator: addToRotator, playVideo: playVideo, buildGallery: buildGallery };

  function ready() {
    [].forEach.call(document.querySelectorAll('.buffalo-banner-rotator'), addToRotator);
    [].forEach.call(document.querySelectorAll('.bf-fab-gallery'), buildGallery);
    watchRecs();
    document.dispatchEvent(new CustomEvent('bf-fabrica-ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
